document.addEventListener('DOMContentLoaded', function() {
  // Select your custom close button
  const closeBtn = document.querySelector('button.closebtn_cst');
  
  // Select the Shopify header menu summary element
  const menuSummary = document.querySelector('summary.header__icon.header__icon--menu.header__icon--summary[aria-controls="menu-drawer"]');

  if (closeBtn && menuSummary) {
    closeBtn.addEventListener('click', function() {
      menuSummary.click();
    });
  }
});

document.querySelectorAll('h3.service-title').forEach(title => {
  title.addEventListener('click', function() {
    const newWindowWidth = window.innerWidth;
    
    if (newWindowWidth < 768) {
      const nextElement = this.nextElementSibling;
      
      // Basic toggle logic (Vanilla equivalent of slideToggle)
      if (nextElement.style.display === "none" || nextElement.style.display === "") {
        nextElement.style.display = "block";
      } else {
        nextElement.style.display = "none";
      }
      this.nextElementSibling.classList.toggle('is-open');
    }
  });
});



